import { render, staticRenderFns } from "./CompanyReport.vue?vue&type=template&id=67ba3eae&"
import script from "./CompanyReport.vue?vue&type=script&lang=js&"
export * from "./CompanyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports